module.exports = __webpack_public_path__ + "static/media/contest-entry.7a55a993.png";